import React, { useEffect, useRef, useState } from 'react';

const DottedBackground = () => {
  const overlayRef = useRef(null);
  const [isDark, setIsDark] = useState(document.documentElement.classList.contains('dark'));

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (overlayRef.current) {
        const x = e.clientX;
        const y = e.clientY;
        overlayRef.current.style.WebkitMaskImage = `radial-gradient(200px circle at ${x}px ${y}px, black 0%, transparent 100%)`;
        overlayRef.current.style.maskImage = `radial-gradient(200px circle at ${x}px ${y}px, black 0%, transparent 100%)`;
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const dotColor = isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.20)';

  return (
    <div className="fixed inset-0 pointer-events-none z-0">
      {/* Base faint dots */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(circle, ${dotColor} 1px, transparent 1px)`,
          backgroundSize: '10px 10px'
        }}
      ></div>
      
      {/* Blue dots revealed by cursor */}
      <div 
        ref={overlayRef}
        className="absolute inset-0 opacity-70"
        style={{
          backgroundImage: 'radial-gradient(circle, #3b82f6 1px, transparent 1px)',
          backgroundSize: '10px 10px',
          WebkitMaskImage: `radial-gradient(200px circle at -1000px -1000px, black 0%, transparent 100%)`,
          maskImage: `radial-gradient(200px circle at -1000px -1000px, black 0%, transparent 100%)`,
        }}
      ></div>
    </div>
  );
};

export default DottedBackground;
